import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import SelectCustom from '../elements/SelectCustom'; 
import InputCustom from '../elements/InputCustom';   
    
import ButtonTextCustom from '../elements/ButtonTextCustom';
import { BiSolidDownArrow } from "react-icons/bi";

import MultipleChoice from './MultipleChoice';
import MultipleChoiceWithImage from './MultipleChoiceWithImage';
import OpenAnswer from './OpenAnswer';
import CompleteBlanks from './CompleteBlanks';

import { EditIcon,
         LanguageIcon,
         DragIndicatorIcon, } from '../../helpers/icons';

import { dataObjectMultipleChoice,
        //dataObjectMultipleChoiceTrivia,
         getNameLanguage,
         dataObjectMultipleChoiceWithImage,
         //dataObjectMultipleChoiceWithImageTrivia,
         dataObjectOpenAnswer,
         getTypeAssesment, } from '../../helpers/functions';

import { ContentContext,
         ConfigurationContext } from '../../context';

import { useTranslation } from 'react-i18next';

const WrapperStyled = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    flex-direction: column;
    .box_question{
        width: 100%;
        .question_number{
            width: 100%;
        }
        .question_type_box{
            width: 100%!important;
            .icon{
                width: 20px!important;
                margin-right: 25px!important;
            }
            .field_input_type{
                width: calc(100% - 614px) !important;
                margin-right: 25px!important;
            }
            .field_score{
                width: 220px!important;
                margin-right: 25px!important;
            }
            .field_show_correct{
                width: 300px!important;
                margin-right: 0!important;
            }
            
        }
    }
    .question_type_container.show{
        display: flex;
        flex-direction: column;
    }
    .question_type_container.hide{
        display: none;
    }
    .box_lang{
        .question_type_container{
            padding: 35px 50px;
            box-sizing: border-box;
            background-color: ${props => `rgb(${props.pancolors.light_white})`};
            margin-top: 0;
            border-radius: 8px;
            .title{
                display: flex;
                flex-direction: row;
                align-items: center;
                .icon{
                    display: flex;
                    svg{
                        fill: ${props => `rgb(${props.pancolors.black_overwhite})`};  
                    }
                }
                .text{
                    color: ${props => `rgb(${props.pancolors.black_overwhite})`};
                    font-size: 20px;
                    line-height: 20px;
                    font-weight: 600;
                    margin-left: 7px;
                }
            }
            .field_text_modal{
                margin-top: 25px;
            }
        }
        &.error{
            border: 1px solid ${props => `rgb(${props.pancolors.red})`}!important;
            .head_form_lang{
                >.title{
                    .icon{
                        svg{
                            fill: ${props => `rgb(${props.pancolors.red})`}!important;
                        }
                    }
                    .text{
                        color: ${props => `rgb(${props.pancolors.red})`}!important;
                    }
                }
            }
        }
        &.multilang{
            box-sizing: border-box;
            padding: 0px 30px 0px;
            background-color: ${props => `rgb(${props.pancolors.light_white})`};
            border: 1px solid ${props => `rgb(${props.pancolors.light_white})`};
            margin-bottom: 20px;
            .question_type_container{
                padding: 5px 50px;
            }
            &.open{
                padding: 0px 30px 20px;
            }
            .head_form_lang{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 20px 0 20px 0;
                
                >.title{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .icon{
                        svg{
                            width: 40px;
                            height: 40px;
                        }
                    }
                    .text{
                        font-size: 22px;
                        line-height: 22px;
                        font-weight: 700;
                        color: ${props => `rgb(${props.pancolors.dots})`};
                        margin-left: 10px;
                    }
                }
            }
        }
    }
`

const QuestionContainer = (props) => {

    const { t } = useTranslation();

    const { panColors, 
            userCountrySelected } = useContext(ConfigurationContext);
    
    const { basicData } = useContext(ContentContext);

    const { assessmentType,
            blockAction,
            setBlockAction,
            contentByLang, 
            setContentByLang,
            evaluationData,
            questions,
            questionSelected,
            setQuestionSelected,
            questionSelectedOrder,
            langHaveError } = props;
            

    const [ dataQuestion, setDataQuestion ] = useState(null);
    const [ evaluationTypes, setEvaluationTypes ] = useState([]);
    //const [ langHaveError, setLangHaveError ] = useState([]);
    const [ showLanguage, setShowLanguage ] = useState(null);

    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};

    const show_correct_drop_options = [{_id: "true", name: "Si"}, {_id: "false", name: "No"}];

    const handleFormElementChange = (name, value) => {
        const questionSelectedUpdate = {...questionSelected};
        const contentByLangUpdate = {...contentByLang};
        if(name === "input_type"){
            
            const type = 'evaluation_lineal';//getTypeAssesment(basicData.assessment_type, evaluationData.type_assessment.value);
            
            Object.keys(contentByLangUpdate.translations).map(function(key) {
                contentByLangUpdate.translations[key].questions[questionSelectedOrder].title.value = '';
                contentByLangUpdate.translations[key].questions[questionSelectedOrder].media.value = '';
                contentByLangUpdate.translations[key].questions[questionSelectedOrder].media.cropped_image = '';
            })

            switch (value) {

                case "single_choice":
                    
                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [JSON.parse(JSON.stringify(dataObjectMultipleChoice(null, type))), JSON.parse(JSON.stringify(dataObjectMultipleChoice(null, type)))];
                        
                    }) 

                    break;
                case "multiple_choice":

                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [JSON.parse(JSON.stringify(dataObjectMultipleChoice(null, type))), JSON.parse(JSON.stringify(dataObjectMultipleChoice(null, type))), JSON.parse(JSON.stringify(dataObjectMultipleChoice(null, type)))];
                        
                    }) 
                    
                    break;
                case "single_choice_image":
                    
                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 1, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 2, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 3, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 4, type)))];
                        
                    }) 
                    
                    break;
                case "multiple_choice_image":

                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 1, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 2, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 3, type))), 
                                                                                                                       JSON.parse(JSON.stringify(dataObjectMultipleChoiceWithImage(null, 4, type)))];
                    }) 
                    
                    break;
                case "comments":

                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].secondary_actions_error = false;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [];
                    }) 
                    
                    break;
                case "complete_blanks":

                    Object.keys(contentByLangUpdate.translations).map(function(key) {
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].input_type.value = value;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder].secondary_actions_error = false;
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]['secondary_actions'] = [];
                    }) 
                    
                    break;
                default:
                    return null;
            }
            
           

        }else{
            if(name !== "text_modal"){
                Object.keys(contentByLangUpdate.translations).map(function(key) {
                    contentByLangUpdate.translations[key].questions[questionSelectedOrder][name].value = value;
                    if(name === "show_correct"){
                        contentByLangUpdate.translations[key].questions[questionSelectedOrder]["text_modal"].value = "";
                        if(value === "true"){
                            contentByLangUpdate.translations[key].questions[questionSelectedOrder]["text_modal"].disabled = false;
                        }else{
                            contentByLangUpdate.translations[key].questions[questionSelectedOrder]["text_modal"].disabled = true;
                        }
                    }
                })
            }else{
                contentByLangUpdate.translations[showLanguage].questions[questionSelectedOrder][name].value = value;
            }
        }
        
        setContentByLang(contentByLangUpdate);
        return null;
        
    }    
    //*611
    const handleShowLanguage = (lang) => {
        if(lang !== showLanguage){
            setShowLanguage(lang);
        }else{
            setShowLanguage(null);
        }
    }

    useEffect(() => {
        
        if(basicData){
            const arrQuestionType = [];
            basicData.questions_type.map((type, index) => {
                arrQuestionType.push({_id: type.title, name: type.label});
            })
            setEvaluationTypes(arrQuestionType);


        }
    
      return () => {}
    }, [basicData])

    useEffect(() => {
        if(userCountrySelected){
            setShowLanguage(userCountrySelected.languages[0].language_identifier);
        }
    return () => {}
    }, [userCountrySelected])

    useEffect(() => {
        setShowLanguage(userCountrySelected.languages[0].language_identifier);
    return () => {}
    }, [questionSelectedOrder])

    
    if(!Object.keys(contentByLang).length || questionSelectedOrder === null || !evaluationTypes.length){
        return null;
    }

    //return null;

    return (
        <WrapperStyled pancolors={panColors}>
                
                <div className="box_question">
                    <div className='question_number'>{t("texts.Pregunta")} {questionSelectedOrder + 1}</div>
                    <div className='question_type_box'>
                        <div className='icon'>
                            <DragIndicatorIcon />
                        </div>
                        {evaluationTypes.length ?
                            <SelectCustom 
                                name={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.ref}
                                label={t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.label)}
                                placeholder={t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.placeholder)}
                                onChange={handleFormElementChange}
                                className={`field field_${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.ref}${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.error ? " error" : ""}`}
                                type="text"
                                value={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type.value/*questionSelected.input_type?.value*/}
                                help=""
                                isRequired={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.required}
                                styles={ formStyle }
                                label_icon={null}
                                tooltip_content={null}
                                haveError={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type?.error}
                                data={evaluationTypes}
                            /> : ""
                        }
                        <SelectCustom 
                            name={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.ref}
                            label={t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.label)}
                            //placeholder={questionSelected.score?.placeholder}
                            placeholder={null}
                            onChange={handleFormElementChange}
                            className={`field field_${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.ref}${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.value}
                            help={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.help}
                            isRequired={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.required}
                            styles={ formStyle }
                            label_icon={null}
                            tooltip_content={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.tooltip_content ? t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.tooltip_content) : ""}
                            haveError={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].score?.error}
                            data={basicData?.value_points_trivias}
                        />
                        <SelectCustom 
                            name={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.ref}
                            label={t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.label)}
                            //placeholder={questionSelected.score?.placeholder}
                            placeholder={null}
                            onChange={handleFormElementChange}
                            className={`field field_${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.ref}${contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.value}
                            help={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.help}
                            isRequired={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.required}
                            styles={ formStyle }
                            label_icon={null}
                            tooltip_content={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.tooltip_content ? t("texts."+contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.tooltip_content) : ""}
                            haveError={contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].show_correct?.error}
                            data={show_correct_drop_options}
                        />
                        {/* <SelectCustom 
                            name={questionSelected.penalty_score?.ref}
                            label={t("texts."+questionSelected.penalty_score?.label)}
                            //placeholder={questionSelected.penalty_score?.placeholder}
                            placeholder={null}
                            onChange={handleFormElementChange}
                            className={`field field_${questionSelected.penalty_score?.ref}${questionSelected.penalty_score?.error ? " error" : ""}`}
                            type="text"
                            value={questionSelected.penalty_score?.value}
                            help={questionSelected.penalty_score?.help}
                            isRequired={questionSelected.penalty_score?.required}
                            styles={ formStyle }
                            label_icon={null}
                            tooltip_content={questionSelected.penalty_score?.tooltip_content ? t("texts."+questionSelected.penalty_score?.tooltip_content) : ""}
                            haveError={questionSelected.penalty_score?.error}
                            data={basicData?.value_points}
                        />
                        <SelectCustom 
                            name={questionSelected.id_module?.ref}
                            label={t("texts."+questionSelected.id_module?.label)}
                            placeholder={questionSelected.id_module?.placeholder ? t("texts."+questionSelected.id_module?.placeholder) : ""}
                            onChange={handleFormElementChange}
                            className={`field field_${questionSelected.id_module?.ref}${questionSelected.id_module?.error ? " error" : ""}`}
                            type="text"
                            value={questionSelected.id_module?.value}
                            help={questionSelected.id_module?.help}
                            isRequired={questionSelected.id_module?.required}
                            styles={ formStyle }
                            label_icon={null}
                            tooltip_content={questionSelected.id_module?.tooltip_content}
                            haveError={questionSelected.id_module?.error}
                            data={basicData?.content}
                        /> */}
                    </div>
                </div>
                
                {contentByLang?.translations[userCountrySelected.languages[0].language_identifier].questions[questionSelectedOrder].input_type.value.length ?
                    userCountrySelected?.languages.map((lang, index) => {
                        return(
                            <div className={`box_lang ${userCountrySelected?.languages?.length > 1 ? " multilang" : ""}${(langHaveError.filter(langerror => langerror === lang.language_identifier).length ? ' error' : '')}${showLanguage === lang.language_identifier ? ' open' : ''}`}>
                                {userCountrySelected?.languages?.length > 1 &&
                                <div className="head_form_lang">
                                    <div className="title">
                                        <div className="icon">
                                            <LanguageIcon />
                                        </div>
                                        <div className="text">
                                            {t("texts.Pregunta en")} { getNameLanguage(userCountrySelected?.languages, lang.language_identifier) }
                                        </div>
                                    </div>
                                    {userCountrySelected?.languages.length ?
                                    <ButtonTextCustom 
                                        className="bt_show_more_info"
                                        text={`${showLanguage === lang.language_identifier ? t("texts.Cerrar") : t("texts.Abrir")}`}
                                        onClick={() => handleShowLanguage(lang.language_identifier)}

                                        icon={<BiSolidDownArrow />}
                                        background={{ normal: "", hover: "" }}
                                        border={{ normal: "", hover: "" }}
                                        textcolor={{ normal: panColors.primary, hover: panColors.primary }}
                                    /> : "" }
                                </div>
                                }


                                <div className={`question_type_container content_form${showLanguage === lang.language_identifier ? ' show' : ' hide'}`}>
                                    <div className="title">
                                        <div className="icon">
                                            <EditIcon />
                                        </div>
                                        <div className="text">
                                            {t("texts.Editar pregunta")}
                                        </div>
                                    </div>
                                    
                                    {!contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.disabled ? 
                                    <InputCustom 
                                        name={contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.ref}
                                        label={t("texts."+contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.label)}
                                        placeholder={t("texts."+contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.placeholder)}
                                        onChange={handleFormElementChange}
                                        onKeyDown={null}
                                        className={`field field_${contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.ref}${contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.error ? " error" : ""}`}
                                        type="text"
                                        value={contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.value}
                                        help={contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.help}
                                        isRequired={contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.required}
                                        styles={ formStyle }
                                        label_icon={null}
                                        tooltip_content={null}
                                        haveError={contentByLang?.translations[lang.language_identifier]?.questions[questionSelectedOrder].text_modal.error}
                                    /> : ""}

                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "single_choice" ?
                                        <MultipleChoice 
                                            data={dataQuestion}    
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected}
                                            questionSelectedOrder={questionSelectedOrder}
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            imageReference={true}
                                            response_multiple={false}
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""}

                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "multiple_choice" ?
                                        <MultipleChoice 
                                            data={dataQuestion}
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected}
                                            questionSelectedOrder={questionSelectedOrder}
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            imageReference={true}
                                            response_multiple={true}
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""}

                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "single_choice_image" ?
                                        <MultipleChoiceWithImage 
                                            data={dataQuestion} 
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected} 
                                            questionSelectedOrder={questionSelectedOrder}  
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            response_multiple={false}
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""}

                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "multiple_choice_image" ? 
                                        <MultipleChoiceWithImage 
                                            data={dataQuestion}
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected}
                                            questionSelectedOrder={questionSelectedOrder}
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            response_multiple={true}
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""}
                                    
                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "comments" ? 
                                        <OpenAnswer 
                                            data={dataQuestion}
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected}
                                            questionSelectedOrder={questionSelectedOrder}
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""} 

                                    {contentByLang.translations[lang.language_identifier].questions[questionSelectedOrder].input_type.value === "complete_blanks" ? 
                                        <CompleteBlanks 
                                            data={dataQuestion}
                                            questionSelected={questionSelected}
                                            setQuestionSelected={setQuestionSelected}
                                            questionSelectedOrder={questionSelectedOrder}
                                            contentByLang={contentByLang} 
                                            setContentByLang={setContentByLang}
                                            lang={lang.language_identifier}
                                            questions={questions/*(assessmentType != null && assessmentType === "evaluation_lineal") ? null : questions*/} 
                                            blockAction={blockAction}
                                            setBlockAction={setBlockAction}
                                        />
                                    : ""} 

                                    

                                </div>

                                </div>




                        )
                    })
                
                : ""}


            
        </WrapperStyled>
    );
}

export default React.memo(QuestionContainer);